import React from 'react';

// FIX: Use React.PropsWithChildren to correctly type components that accept children via JSX.
const IconCardWrapper = ({ children, className }: React.PropsWithChildren<{ className: string }>) => (
    <div className={`w-20 h-20 rounded-xl flex items-center justify-center text-white shadow-lg mb-4 ${className}`}>
        {children}
    </div>
);

// FIX: Use React.PropsWithChildren to correctly type components that accept children via JSX.
const IconSvg = ({ children }: React.PropsWithChildren<{}>) => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-9 w-9" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        {children}
    </svg>
);

export const MergeIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-purple-500 to-indigo-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 8h14M5 12h14M5 16h14M3 8l4 4-4 4M21 8l-4 4 4 4" />
        </IconSvg>
    </IconCardWrapper>
);

export const SplitIconCard = () => (
     <IconCardWrapper className="bg-gradient-to-br from-sky-500 to-cyan-500">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-5-9.25V6.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v2.25M17 17.75V17.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v.25M5 12h14" />
        </IconSvg>
    </IconCardWrapper>
);

export const ExtractIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-emerald-500 to-green-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 4v6l-2-2m4 0l-2 2m-2-4h10a2 2 0 012 2v11a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2zm2 14v-2m4 2v-2" />
        </IconSvg>
    </IconCardWrapper>
);

export const ResumeIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-amber-500 to-orange-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h7" />
        </IconSvg>
    </IconCardWrapper>
);

export const PdfToDocxIconCard = () => (
     <IconCardWrapper className="bg-gradient-to-br from-blue-500 to-sky-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </IconSvg>
    </IconCardWrapper>
);

export const DocxToPdfIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-blue-600 to-purple-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h-5a2 2 0 00-2 2v4a2 2 0 002 2h5" opacity="0.4"/>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 7l4-4 4 4" opacity="0.6"/>
        </IconSvg>
    </IconCardWrapper>
);

export const PptxToPdfIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-orange-500 to-red-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM7 3h10v4H7V3z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 11v6m-2-4h4" />
        </IconSvg>
    </IconCardWrapper>
);

export const ImageToPdfIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-rose-500 to-red-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </IconSvg>
    </IconCardWrapper>
);

export const ExtractImagesIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-yellow-500 to-amber-600">
        <IconSvg>
             <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
             <path strokeLinecap="round" strokeLinejoin="round" d="M18 10h2m-2-4h2m-2 8h2" opacity="0.6" />
        </IconSvg>
    </IconCardWrapper>
);

export const CompressIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-teal-500 to-cyan-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7M9 5v14h2" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M20 5v14h-2" />
        </IconSvg>
    </IconCardWrapper>
);

export const ProtectIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-slate-500 to-gray-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </IconSvg>
    </IconCardWrapper>
);

export const WatermarkIconCard = () => (
    <IconCardWrapper className="bg-gradient-to-br from-pink-500 to-rose-600">
        <IconSvg>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a3 3 0 100-6 3 3 0 000 6z" opacity="0.4" />
        </IconSvg>
    </IconCardWrapper>
);

export const UploadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M12 15V9m-4 4l4-4 4 4" />
    </svg>
);

export const PdfIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 12h4" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 16h4" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 8h1" />
    </svg>
);

export const ImageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-cyan-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
);

export const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
);

export const MergeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 8h14M5 12h14M5 16h14M3 8l4 4-4 4M21 8l-4 4 4 4" />
    </svg>
);

export const SplitIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-5-9.25V6.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v2.25M17 17.75V17.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v.25M5 12h14" />
    </svg>
);

export const ExtractIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 4v6l-2-2m4 0l-2 2m-2-4h10a2 2 0 012 2v11a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2zm2 14v-2m4 2v-2" />
    </svg>
);

export const ExtractImagesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M1 12h5m-5-4h5m-5 8h5" />
    </svg>
);

export const ResumeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h7" />
    </svg>
);

export const ConvertIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
    </svg>
);

export const DownloadIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
);

export const CopyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
);

export const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
);

export const SpinnerIcon = () => (
    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);

export const ErrorIcon = () => (
     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

export const GithubIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>
    </svg>
);

export const CompressIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7M9 5v14h2" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 5v14h-2" />
    </svg>
);

export const ProtectIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
);

export const WatermarkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 12a3 3 0 100-6 3 3 0 000 6z" opacity="0.4" />
    </svg>
);